﻿import { Switch } from 'antd';
import React from 'react';
import { ComponentConfigsMap } from '../forms/ComponentsMap';
import { MapControlsState } from '../models/MapControlsState';
import { switchFormItemProps, switchProps } from './styles';

/**
 * Describes components used to create a UI for a map controls store
 */
export const mapControlsConfig: ComponentConfigsMap<MapControlsState> = {
    showZoom: {
        label: "Zoom control",
        formItem: switchFormItemProps,
        component: <Switch {...switchProps} />
    },
    showScale: {
        label: "Scale line",
        formItem: switchFormItemProps,
        component: <Switch {...switchProps} />
    },
    showCoordinate: {
        label: "Mouse coordinates",
        formItem: switchFormItemProps,
        component: <Switch {...switchProps} />
    }
}
